// extracted by mini-css-extract-plugin
export default {"shell":"AppShell_shell__Ngvpv","main":"AppShell_main__5nhtB","content":"AppShell_content__LGqyI"};